import React, { useEffect } from 'react';
import { Toaster } from 'react-hot-toast';

const UserLayout = ({ children }) => {
  useEffect(() => {
  }, []);


  return (
    <div >
    <main>
      <div >{children}</div>
      <Toaster 
      toastOptions={{
        className: '',
        style: {
          fontSize : '15px'
        },
      }}
      />
    </main>
    
  </div>
  );
};

export default UserLayout;
